/* ce-redesign.js
   1) toggles the docked state on the store header (styling only)
   2) keeps --ce-header-h equal to the header's *live* height so the scrolling
      bar sticks flush beneath it. A ResizeObserver re-measures whenever the
      header changes size (font load, dock, locale wrap, Convermax, etc.) so the
      marquee can never drift out of sync and open a gap. */
(function () {
  function init() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var publishHeight = function () {
      // round down so sub-pixel heights never leave a 1px seam
      var h = Math.floor(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--ce-header-h', h + 'px');
    };
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      header.classList.toggle('ce-docked', y > 30);
    };

    publishHeight();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', publishHeight, { passive: true });
    window.addEventListener('load', publishHeight);

    // re-pin whenever the header actually changes size, for any reason
    if (window.ResizeObserver) {
      new ResizeObserver(publishHeight).observe(header);
    } else {
      setTimeout(publishHeight, 300);
      setTimeout(publishHeight, 1000);
    }
    // also after web fonts settle
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(publishHeight);

    // --- Mobile search overlay: free it from the header's containing block ---
    // The header pill has backdrop-filter, which makes it the containing block
    // for position:fixed children — that traps the full-screen search overlay
    // inside the pill. While the search <details> is open, flag the header (and
    // <html>) so CSS can drop backdrop-filter/transform on the header ancestors
    // (so fixed resolves to the viewport) and lock background scroll. This is a
    // JS fallback to the CSS :has() rule so the fix works even where :has() is weak.
    var searchDetails = header.querySelector('.header__search details');
    if (searchDetails) {
      var syncSearch = function () {
        var open = searchDetails.hasAttribute('open');
        header.classList.toggle('ce-search-open', open);
        document.documentElement.classList.toggle('ce-search-open', open);
      };
      searchDetails.addEventListener('toggle', syncSearch);
      syncSearch();
    }

    // --- Force the Convermax "Select Your Vehicle" title white ---
    // Convermax sets it black via an inline/high-specificity rule that CSS can't
    // beat, so apply an inline !important (which wins) and re-apply on re-render.
    var whitenTitles = function () {
      document.querySelectorAll('.cm_vehicle-widget_title, .cm_vehicle-widget_title *')
        .forEach(function (el) { el.style.setProperty('color', '#ffffff', 'important'); });
    };
    whitenTitles();
    [300, 1000, 2500].forEach(function (ms) { setTimeout(whitenTitles, ms); });
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t); t = setTimeout(whitenTitles, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
